@import "/src/styles/mixins.sass"

.disabled
    pointer-events: none

.unstyled, .styled
    @include reset
    color: var(--color-black-primary)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    gap: 0.75rem

    span
        display: flex
        align-items: center
        white-space: nowrap
        gap: 0.75rem

.unstyled
    @include clickable

.styled
    @include label-large
    @include clickable-styled($subclasses: true)
    padding: 1rem
